<div class="card-container">
  <glxy-contact-info-card *ngFor="let cardData of cardData$ | async" [cardData]="cardData"></glxy-contact-info-card>
</div>
<div class="nav-container">
  <button *ngIf="showTickets" class="details-button" (click)="ticketsClicked.emit()">
    <span class="details-button__title">{{ 'INBOX.TICKETS.TITLE' | translate }}</span>
    <mat-icon class="details-button__icon">chevron_right</mat-icon>
  </button>
</div>
